export enum TaskStatus {
    OPEN,
    STARTED,
    FINISHED
}

